import serviceProvider from '../../services/provider/ProviderService'
import { StorageService } from '../../services/StorageService'
import * as moment from 'moment'
import io from 'socket.io-client'
import ApiService from '../../services/ApiService'
import { min } from 'lodash'

export default {
  components: {
  },
  data: () => ({
    providers: [],
    selectedProviders: [],
    selectedProvidersSent: [],
    rules: {
      required: value => !!value || 'El campo es requerido'
    },
    menuInitialDate: false,
    initialDate: '',
    menuFinalDate: false,
    finalDate: '',
    minDate: '',
    io: null,
    socket: null,
    showDownloadBox: false,
    generatingReport: false,
    link: '',
    linkProvider: '',
    fail: false,
    menuInitialDate2: false,
    initialDate2: '',
    menuFinalDate2: false,
    finalDate2: '',
    minDate2: '',
    menuInitialDate3: false,
    initialDate3: '',
    menuFinalDate3: false,
    finalDate3: '',
    minDate3: '',
    maxDate: '',
    maxDate2: '',
    maxDate3: '',
    maxAyer: '',
    minAnio: '',
    rangoDias: 15,
    showReport: false
  }),
  created () {
    this.getProviders()
    this.maxAyer= moment().subtract(1, 'days').format('YYYY-MM-DD')
    const anioAnterior=moment().subtract(1, 'year').format('YYYY')
    this.minAnio= anioAnterior.concat('-01-01')
  },

  computed: {
  },

  watch: {
  },

  methods: {
    async getProviders () {
      try {
        const response = await serviceProvider.getProviders()
        const integratedProvider = StorageService.getIntegratedProvider()
        const user = StorageService.getUserData()
        this.providers = response.data.filter(
          item => item.id !== integratedProvider && item.name !== 'FARMACIA UNIFICADA' && item.name !== '' && item.name !== 'DEMPOS FARMACIA' && item.name !== 'FARMACIAS NOVA'
        )
        if (user.providerId!=='' && user.providerId!==1 ){
          this.providers = this.providers.filter(item => item.id == user.providerId )
        } 
        else{
          this.providers.unshift({ name: 'INTEGRADOS' })
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
      }
    },
    changeInitialDate () {
      let initialDate = moment(this.initialDate).format('YYYY-MM-DD')
      this.minDate = initialDate
      if (this.finalDate !== null & this.finalDate !== undefined && this.finalDate !== '') {
        if (!moment(this.finalDate).isSameOrAfter(initialDate)) {
          this.finalDate = this.minDate
        }
      } else {
        this.finalDate = this.minDate
      }
    },
    changeInitialDate2 () {
      let initialDate2 = moment(this.initialDate2).format('YYYY-MM-DD')
      this.minDate2 = initialDate2
      if (this.finalDate2 !== null & this.finalDate2 !== undefined && this.finalDate2 !== '') {
        if (!moment(this.finalDate2).isSameOrAfter(initialDate2)) {
          this.finalDate2 = this.minDate
        }
      } else {
        this.finalDate2 = this.minDate2
      }
    },
    changeInitialDate3 () {
      let initialDate3 = moment(this.initialDate3).format('YYYY-MM-DD')
      this.minDate3 = initialDate3
      if (this.finalDate3 !== null & this.finalDate3 !== undefined && this.finalDate3 !== '') {
        if (!moment(this.finalDate3).isSameOrAfter(initialDate3)) {
          this.finalDate3 = this.minDate
        }
      } else {
          this.finalDate3 = this.minDate3
      } 
    },

    async generateReportOrders () {
      let fechaLimite = new Date(this.minDate);
      fechaLimite.setDate(fechaLimite.getDate() + this.rangoDias);
      let formattedDate = fechaLimite.toString();
      let maxDateFormat = moment(formattedDate).format('YYYY-MM-DD')
      if (this.finalDate > maxDateFormat) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: `Rango entre fechas debe ser menor o igual a ${this.rangoDias} días`
        })
        this.generatingReport = false
        return  
      }
      if (this.finalDate === null || this.finalDate === undefined || this.finalDate === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha final'
        })
        return
      }
      if (this.initialDate === null || this.initialDate === undefined || this.initialDate === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha inicial'
        })
        return
      }
      this.showDownloadBox = true
      this.generatingReport = true
      const data = {
        providers: this.selectedProviders,
        initialDate: this.initialDate,
        finalDate: this.finalDate
      }
      this.fail = false
      this.showReport = false
      ApiService.post("/report/reportorders", {data})
      .then(response => {
        this.generatingReport = false
        let dataLink = null
        dataLink = response.data.data
        if (dataLink.length > 1 ){
          this.showReport = true
          this.linkProvider = dataLink[0]
          this.link = dataLink[1]
        } else {
          this.link = dataLink[0]
          this.generatingReport = false
          this.showReport = false
        }
      })
        .catch(error => {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'Hubo un error obteniendo el reporte '
          })
          console.log(error);
        })
    },

    async generateReportSent () {
      let fechaLimite = new Date(this.minDate3);
      fechaLimite.setDate(fechaLimite.getDate() + this.rangoDias);
      let formattedDate = fechaLimite.toString();
      let maxDateFormat = moment(formattedDate).format('YYYY-MM-DD')
      
      if (this.finalDate3 > maxDateFormat) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: `Rango entre fechas debe ser menor o igual a ${this.rangodias} días`
        })
        this.generatingReport = false
        return 
      }
      if (this.initialDate3 === null || this.initialDate3 === undefined || this.initialDate3 === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha inicial'
        })
        return
      }
      if (this.finalDate3 === null || this.finalDate3 === undefined || this.finalDate3 === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha final'
        })
        return
      }
      if (this.selectedProvidersSent === null || this.selectedProvidersSent === undefined || this.selectedProvidersSent === '' || this.selectedProvidersSent.length === 0) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debes seleccionar mínimo a un prestador'
        })
        return
      }
      const data = {
        providers: this.selectedProvidersSent,
        initialDate: this.initialDate3,
        finalDate: this.finalDate3
      }
      this.fail = false
      this.generatingReport = true
      this.showDownloadBox = true
      ApiService.post("/report/oportunity", {data})
      .then(response => {
          this.generatingReport = false
          let dataLink = null
          dataLink = response.data.data
          if (dataLink.length > 1 ){
            this.showReport = true
            this.linkProvider = dataLink[0]
            this.link = dataLink[1]
          } else {
            this.link = dataLink[0]
            this.showReport = false
          }
        })
        .catch(error => {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'Hubo un error obteniendo el reporte '
          })
          console.log(error);
        })
      this.selectedProviders = []
    },

    async generateReportPendings () {
      let fechaLimite = new Date(this.minDate2);
      fechaLimite.setDate(fechaLimite.getDate() + this.rangoDias);
      let formattedDate = fechaLimite.toString();
      let maxDateFormat = moment(formattedDate).format('YYYY-MM-DD')
      if (this.finalDate2 > maxDateFormat) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: `Rango entre fechas debe ser menor o igual a ${this.rangodias} días`
        })
        this.generatingReport = false
        return 
      }
      if (this.finalDate2 === null || this.finalDate2 === undefined || this.finalDate2 === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha final'
        })
        return
      }
      if (this.initialDate2 === null || this.initialDate2 === undefined || this.initialDate2 === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha inicial'
        })
        return
      }
      this.showDownloadBox = true
      this.generatingReport = true
      const data = {
        initialDate: this.initialDate2,
        finalDate: this.finalDate2
      }
      this.fail = false
      this.showReport = false
      ApiService.post("/report/reportpending", {data})
      .then(response => {
          this.generatingReport = false
          let dataLink = null
          console.log('response', response)
          dataLink = response.data.data
          if (dataLink.length > 1 ){
            this.showReport = true
            this.linkProvider = dataLink[0]
            this.link = dataLink[1]
          } else {
            this.link = dataLink[0]
            this.generatingReport = false
            this.showReport = false
          }
        })
        .catch(error => {
          this.$notify({
            group: 'app',
            type: 'error',
            text: 'Hubo un error obteniendo el reporte '
          })
          console.log(error);
        })
    }
  }
}
